import { UserSession } from '../../interfaces/User';
import { StoreHandler } from './CommonStoreProvider';
import { Customer } from '../../interfaces/Customer';
import { Roles } from '../..';

let KEY_SESSION = 'localstorage:de.dew21.desktop:KEY_SESSION';

let defaultStoreHandler: StoreHandler | null = null;
export const use = (storeHandler: StoreHandler, sessionKey?: string) => {
	defaultStoreHandler = storeHandler;
	KEY_SESSION = sessionKey || KEY_SESSION;
}

export const setSession = (session: UserSession | null) => {
	defaultStoreHandler?.set<UserSession>(KEY_SESSION, session);
}

export const getSession = (): UserSession | null => {
	return defaultStoreHandler?.get<UserSession>(KEY_SESSION) || null;
}

export const getCurrentUserId = (): string | null => {
	return getSession()?.id || null;
}

export const hasCustomerEditPermission = (customer?: Customer) => {
	const role = getSession()?.role;
	return (role !== undefined && [Roles.ADMIN, Roles.SUPER_USER].includes(role)) || (customer?.responsibleConsultant === getCurrentUserId());
}

export const getAuthToken = (): string | null => {
	return getSession()?.tokens?.accessToken || null;
}
export const getAuthHeader = (): { [key: string]: any } => {
	return { headers: { 'Authorization': `Bearer ${getAuthToken()}` } };
}
